import React from 'react';
import {
  Actions,
  HeaderCenter,
  HeaderSide,
  LinkBtn,
  LinkWrapper,
  ModalHeader,
} from 'app/pages/library/videos/videoList/components/SendAndShare';
import { MdClose, MdSave } from 'react-icons/md';
import { ModalTitle } from '../styles';
import { ButtonPillSwitch } from 'lib/components';
import { theme } from 'lib/style';
import { MeetingResponse, MEETING_STATUSES } from 'lib/api/meetings/types';

import { getMeetingTabs } from '../constants';
import { ModalMeetingsDetails } from '../pages/MeetingDetails';
import { useIsMutating } from 'react-query';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';
import { FaRegCalendarXmark } from 'react-icons/fa6';
import { IoMdSend } from 'react-icons/io';
import { useFormikContext } from 'formik';
import { FormikMeetingsValues } from '../types';

interface IProps {
  setShowDetailsModals: React.Dispatch<
    React.SetStateAction<ModalMeetingsDetails>
  >;
  handleCloseFullScreenModal: () => void;
  meetingDetails: MeetingResponse | undefined;
  meetingId: string | null;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  activeTab: string;
  isRecurring?: boolean;
  onStartNowClick: () => Promise<void>;
}

export const MeetingsFormikDetailsHeader = (props: IProps) => {
  const { submitForm, values, dirty } =
    useFormikContext<FormikMeetingsValues>();
  const {
    handleCloseFullScreenModal,
    meetingId,
    meetingDetails,
    setShowDetailsModals,
    setActiveTab,
    activeTab,
    isRecurring,
  } = props;
  const { t } = useTranslation();
  const MEETING_TABS = getMeetingTabs(t);

  const isCanceled =
    meetingDetails?.meetingStatus === MEETING_STATUSES.CANCELED;
  const isScheduled =
    meetingDetails?.meetingStatus === MEETING_STATUSES.SCHEDULED;
  const isFinished =
    meetingDetails?.meetingStatus === MEETING_STATUSES.FINISHED;

  const showSendInviteButton = !meetingId;
  const showActionButtons = (isScheduled || isRecurring) && meetingId;
  const showDeleteButton = isFinished || isCanceled;
  const showButtonPillSwitch = !!meetingId;

  const isSubmitting = useIsMutating();

  const headerText = isRecurring
    ? t('Create Recurring Meeting')
    : t('Schedule Meeting');

  return (
    <ModalHeader>
      <HeaderSide>
        <LinkWrapper>
          <LinkBtn
            onClick={() => {
              handleCloseFullScreenModal();
            }}
          >
            <MdClose size='18' />
            <span>{t('Close')}</span>
          </LinkBtn>
        </LinkWrapper>
      </HeaderSide>
      <HeaderCenter>
        <ModalTitle>
          {showButtonPillSwitch ? (
            <ButtonPillSwitch
              defaultValue={activeTab}
              values={MEETING_TABS}
              onChange={newTab => setActiveTab(newTab)}
            />
          ) : (
            headerText
          )}
        </ModalTitle>
      </HeaderCenter>
      <HeaderSide>
        <Actions>
          <>
            {showDeleteButton && (
              <Button
                text={t('Delete')}
                onClick={() => setShowDetailsModals('delete')}
                disabled={!!isSubmitting}
                variant='destructive'
              />
            )}
            {showActionButtons && (
              <>
                <Button
                  onClick={() => setShowDetailsModals('cancel')}
                  icon={
                    <FaRegCalendarXmark
                      color={theme.palette.red100}
                      size={20}
                    />
                  }
                  disabled={!!isSubmitting}
                  variant='ghost'
                />
                <Button
                  text={t('Start now')}
                  onClick={props.onStartNowClick}
                  disabled={!!isSubmitting}
                  variant='secondary'
                />
                <Button
                  onClick={() => {
                    if (!!values.attendees?.length) {
                      setShowDetailsModals('send-notifications');
                      return;
                    }
                    submitForm();
                  }}
                  text={t('Save changes')}
                  disabled={!!isSubmitting || !dirty}
                  variant='primary'
                  icon={<MdSave color={theme.palette.white} />}
                />
              </>
            )}
            {showSendInviteButton && (
              <Button
                icon={<IoMdSend size={18} />}
                disabled={!!isSubmitting || !dirty}
                text={
                  !values.attendees.length
                    ? t('Schedule meeting')
                    : t('Send invite')
                }
                onClick={() => submitForm()}
                variant='primary'
              />
            )}
          </>
        </Actions>
      </HeaderSide>
    </ModalHeader>
  );
};
